var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4933 0.802424C15.4916 0.742424 15.4741 0.685757 15.4583 0.628257C15.4458 0.579924 15.4399 0.530757 15.4191 0.48659C15.3999 0.443257 15.3674 0.408257 15.3391 0.368257C15.3041 0.317424 15.2724 0.26659 15.2274 0.224924C15.2199 0.217424 15.2166 0.207424 15.2083 0.200757C15.1783 0.174924 15.1416 0.165757 15.1091 0.144924C15.0591 0.112424 15.0099 0.0790904 14.9533 0.0574237C14.8974 0.0374237 14.8424 0.0324237 14.7849 0.0240904C14.7449 0.018257 14.7091 -7.62939e-05 14.6666 -7.62939e-05H10.4999C10.0391 -7.62939e-05 9.66659 0.373257 9.66659 0.833257C9.66659 1.29326 10.0391 1.66659 10.4999 1.66659H12.8549L9.49159 5.58992L5.92826 3.45242C5.57576 3.23909 5.12242 3.31742 4.85909 3.63326L0.692425 8.63326C0.398258 8.98659 0.445758 9.51242 0.799091 9.80659C0.955758 9.93659 1.14409 9.99992 1.33242 9.99992C1.57159 9.99992 1.80826 9.89826 1.97326 9.69992L5.68326 5.24826L9.23742 7.38159C9.58659 7.59076 10.0349 7.51742 10.2991 7.20909L13.8333 3.08576V4.99992C13.8333 5.45992 14.2058 5.83326 14.6666 5.83326C15.1274 5.83326 15.4999 5.45992 15.4999 4.99992V0.833257C15.4999 0.822424 15.4941 0.813257 15.4933 0.802424Z",
    fill: "#23BD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTrendingUp);
export default __webpack_public_path__ + "static/media/ProjectTrendingUp.41b5b6eabb9bf38276fbdf2b3a1e435d.svg";
export { ForwardRef as ReactComponent };